import type { TourConfig } from './types';

export const dietTemplatesTour: TourConfig = {
  id: 'diet-templates-page',
  name: 'Diet Templates Tour',
  description: 'Learn how to create and use diet templates',
  requiredPath: '/dashboard/diet-templates',
  steps: [
    {
      element: '[data-tour="templates-header"]',
      popover: {
        title: 'Diet Templates',
        description:
          'Create reusable 7-day meal plan templates. Save time by applying templates to multiple clients.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="templates-create-button"]',
      popover: {
        title: 'Create Template',
        description:
          'Click here to create a new diet template with a 7-day meal grid.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="templates-search"]',
      popover: {
        title: 'Search Templates',
        description: 'Find templates quickly by searching their name.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="templates-table"]',
      popover: {
        title: 'Template List',
        description:
          'View all your templates. Click to edit or use the actions menu to view, edit, or delete.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
